import { useOktaAuth } from '@okta/okta-react'
import oktaLogo from '~/assets/images/okta-logo.png'

export const OktaLoginButton = () => {
  const okta = useOktaAuth()

  if (!okta) return null

  const { oktaAuth } = okta

  const handleLogin = async () => await oktaAuth.signInWithRedirect()

  return (
    <button
      onClick={() => void handleLogin()}
      className="border border-[#dadce0] h-10 rounded text-sm color-[#3c4043] flex items-center px-2 relative bg-[#3E59E4] text-white hover:bg-[#3E59E4]/90"
    >
      <img src={oktaLogo} alt="Okta" className="w-5 h-5" />
      <span className="absolute left-1/2 -translate-x-1/2">Login with Okta</span>
    </button>
  )
}
